import React from "react";
import { Col, Container, Row } from "reactstrap";
import packageJson from "../../package.json";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}>
              {new Date().getFullYear()} © BuyersClub. v{packageJson.version}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
